"use client";

import {
  AGE_GROUP_CHANGED_EVENT,
  AGE_GROUP_KEY,
  type AgeGroup,
  getAgeGroupFromStorage,
} from "@/lib/age-group/store";
import { useEffect, useState } from "react";

export type VisitorAgeState = {
  /**
   * `null` when unknown, or briefly before the first client read from storage.
   * Set by contact birth-year gate, Meta/`pm_auto_age` auto-mark, etc.
   */
  ageGroup: AgeGroup | null;
  isKnownGrownup: boolean;
  isKnownChild: boolean;
};

/** Reactive visitor age from `playmath.ageGroup` (localStorage + cookie mirror). */
export function useVisitorAge(): VisitorAgeState {
  const [ageGroup, setAgeGroup] = useState<AgeGroup | null>(null);

  useEffect(() => {
    const refresh = () => setAgeGroup(getAgeGroupFromStorage());

    refresh();

    const onAgeGroupChanged = () => refresh();
    const onStorage = (e: StorageEvent) => {
      if (e.key === AGE_GROUP_KEY || e.key === null) refresh();
    };

    window.addEventListener(AGE_GROUP_CHANGED_EVENT, onAgeGroupChanged);
    window.addEventListener("storage", onStorage);

    return () => {
      window.removeEventListener(AGE_GROUP_CHANGED_EVENT, onAgeGroupChanged);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  return {
    ageGroup,
    isKnownGrownup: ageGroup === "grownup",
    isKnownChild: ageGroup === "kid",
  };
}
